<script>
	export let height = "currentHeight"
</script>

<svg
	data-svg-carbon-icon="ChevronRight32"
	xmlns="http://www.w3.org/2000/svg"
	fill="currentColor"
	height={height}
	viewBox="0 0 32 32"><path d="M22 16 12 26l-1.4-1.4 8.6-8.6-8.6-8.6L12 6z" /></svg
>
